"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _FeedbackQuestionsState = _interopRequireDefault(require("../store/FeedbackQuestionsState"));
/** @typedef {import("@amzn/coral_com-amazon-trans-feedback-tcfa-model-v-1").Questionnaire} Questionnaire */
/**
 * Use questions hook
 *
 * @returns {{ questions: Questionnaire }}
 */
var useQuestions = function useQuestions() {
  var _useContext = (0, _react.useContext)(_FeedbackQuestionsState["default"]),
    questions = _useContext.questions;
  return {
    questions: questions
  };
};
var _default = exports["default"] = useQuestions;
//# sourceMappingURL=useQuestions.js.map